import { render, staticRenderFns } from "./SalmonProductList.vue?vue&type=template&id=2cff4ea2"
import script from "./SalmonProductList.vue?vue&type=script&lang=js"
export * from "./SalmonProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports